import { render, staticRenderFns } from "./index原版.vue?vue&type=template&id=3c7cf4cb&scoped=true&"
import script from "./index原版.vue?vue&type=script&lang=js&"
export * from "./index原版.vue?vue&type=script&lang=js&"
import style0 from "./index原版.vue?vue&type=style&index=0&id=3c7cf4cb&prod&scoped=true&lang=scss&"
import style1 from "./index原版.vue?vue&type=style&index=1&id=3c7cf4cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7cf4cb",
  null
  
)

export default component.exports